import React from "react";

const Documents = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center">
      <div className="max-w-3xl mx-auto w-full py-8 px-4">
      <h1 className="text-4xl font-bold text-center mb-8 black">Dokumenty</h1>

      <div className="bg-white rounded-lg p-6 mb-8 shadow-md">
        <h2 className="text-2xl font-semibold mb-4 text-black">Formuláře ke stažení</h2>
        <div id="pouceni" className="mb-4 text-gray-700">
        </div>

        <ul className="space-y-2">
        <li><a href="https://drive.usercontent.google.com/download?id=1Zh9ZduyfGzD9wym7_6TdarY9Mvs9faJv&export=download&authuser=0&confirm=t&uuid=15f1783f-6f97-4fdb-b851-70712ef57a49&at=ALBwUglbsLLpARNGGdu7F6gOUZ8j:1779692837061" className="text-gray-500 hover:text-gray-700 hover:underline">Žádost o přihlášení žáka ke studiu</a></li>
        <li><a href="https://drive.usercontent.google.com/download?id=1jIhpE0pTiYL9QH4Z5pRnWC93zCdSZWhG&export=download&authuser=0&confirm=t&uuid=703fdf93-e191-4457-85bb-da03d45ebccf&at=AEz70l7An9E5-TcWSPilCECjBGdI:1741686432524" className="text-gray-500 hover:text-gray-700 hover:underline">Žádost o odhlášení žáka ze studia</a></li>
        </ul>
      </div>

      <div className="bg-white rounded-lg p-6 shadow-md">
        <h2 className="text-2xl font-semibold mb-4 text-black-800">Platné předpisy</h2>
        <ul className="space-y-2">
        <li><a href="https://drive.usercontent.google.com/download?id=1AOMLt64nxvOfrmQYn0nBr5uHBkQRJkbp&export=download&authuser=0&confirm=t&uuid=984ec68f-0306-4a42-a54c-e3bbcc218be4&at=AN8xHoqKsXJn7Wv5Wzk2-RuY71C4:1756710950820" className="text-gray-500 hover:text-gray-700 hover:underline">Školní řád</a></li>
        <li><a href="https://drive.usercontent.google.com/download?id=1M8p-39Q4oMr7dPV5cTg3DYGLNgmEKFvg&export=download&authuser=0&confirm=t&uuid=dde7cd15-2f4e-424c-aab4-3ffcbac0a580&at=AN8xHooRjsYKpJtS5qdviaWlzHa6:1756802016361" className="text-gray-500 hover:text-gray-700 hover:underline">Školní vzdělávací program (ŠVP)</a></li>
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Documents;